import React from 'react';
import { connect } from 'react-redux';
import { Input } from 'antd';
import CheckboxTree from 'react-checkbox-tree';

import { setSitesFromServer, setBrowserData } from 'actions';
import { selectedSiteId, selectedDirectory } from 'actions/selectedElement';
import { backForwardDirectory } from 'actions/backForward';
import requestAPI from 'helpers/requestAPI';
import arrayRecurcive from 'helpers/arrayRecursive';
import addPropsToDirsAndFiles from 'helpers/addPropsToDirsAndFiles';

import './filesTree.scss';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

const FilesTree = ({sitesFromServer, backForward, setFiles, setData, selectingSiteId, selectingDirectoryPath, backForwardDirectory}) => {
  const [ expanded, setExpanded ] = React.useState([]);
  const [ nodes, setNodes ] = React.useState(null);

  
	const onExpand = React.useCallback((expanded, targetNode) => {
    setExpanded( expanded );

    //const { sitesFromServer, backForward, setFiles, setData, selectingSiteId, selectingDirectoryPath, backForwardDirectory } = this.props;
    let clickedDirPath = targetNode.label;
    let siteId = null;

    const isClickedDirIsMainParent = sitesFromServer.find((item) => item.value === targetNode.label);

		if (isClickedDirIsMainParent) {
      clickedDirPath = '';
			siteId = sitesFromServer.find((item) => item.value === targetNode.label).title;
    } else {
      siteId = JSON.parse(targetNode.value).siteId;
      const directory = JSON.parse(targetNode.value).directory
      
      if (directory !== '/') {
        clickedDirPath = directory + '/' + targetNode.label
      }
	  }
	
    selectingSiteId(siteId);
    selectingDirectoryPath(clickedDirPath);

    const backForwardData = {
      back: [ ...backForward.back, {siteId, directory: clickedDirPath}],
      forward: []
    };

    if (backForward.back.length === 0 || backForward.back[backForward.back.length - 1].directory !== clickedDirPath || backForward.back[backForward.back.length - 1].siteId !== siteId) {
      backForwardDirectory(backForwardData)
    } 

		const siteName = sitesFromServer.find((item) => item.title === siteId).label;
		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: siteId,
				directory: clickedDirPath
			}
		};

    requestAPI(params)
    .then((response) => {
      const dirs = addPropsToDirsAndFiles(response, siteName, setData, siteId).dirs
			const currentDirUrl = response.data.data.current_directory;
			const newData = JSON.parse(JSON.stringify(sitesFromServer));
			const index = newData.findIndex((item) => item.title === siteId);

			if (isClickedDirIsMainParent) {
				newData[index].children = dirs;

				setFiles(newData);
			} else {
        const pathArray =  [siteName, ...currentDirUrl.split('/')];
        const newTreeData = JSON.parse(JSON.stringify(sitesFromServer));
        
        arrayRecurcive(newTreeData, dirs, pathArray); //adding new data to treeData
				setFiles(newTreeData);
			}
		});
  }, [setFiles,sitesFromServer,setData,selectingSiteId,selectingDirectoryPath,backForwardDirectory,backForward.back]);
  
  const onKeyUpSearch = (e) => {
    const filterSites = sitesFromServer.filter(el => el.label.indexOf(e.target.value) === 0)
    
    setNodes(filterSites)
  }

	const renderItems = () => {
    if (Object.keys(sitesFromServer).length === 0) return;
    
    return (
      <>
        <Input className="files-tree__search-input" placeholder="Search for sites.." onKeyUp={(e) => onKeyUpSearch(e)} />
        <CheckboxTree
          nodes={nodes || sitesFromServer}
          expanded={expanded}
          onExpand={onExpand}
          onClick={() => {}} //need for CheckboxTree's normal work 
          icons={{
            expandClose: <i className="far fa-folder" />,
            expandOpen: <i className="far fa-folder-open" />
          }}
          expandOnClick={true}
        />
      </>
		);
	};
		return (
			<div className="files-tree">
				<div className="files-tree__items">{renderItems()}</div>
			</div>
		);
}

const mapStateToProps = (state) => {
	return {
		sitesFromServer: state.sites.sitesFromServer,
		backForward: state.navigation.backForward
	};
};

const mapDispatchToProps = (dispatch) => ({
	setFiles: (allSites) => dispatch(setSitesFromServer(allSites)),
	setData: (data) => dispatch(setBrowserData(data)),
	selectingSiteId: (data) => dispatch(selectedSiteId(data)),
	selectingDirectoryPath: (data) => dispatch(selectedDirectory(data)),
	backForwardDirectory: (data) => dispatch(backForwardDirectory(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(FilesTree);
